import Create from "./createComponent"
import Preview from "../components/common/preview.vue"

/**
 * 扩展vue实例组件（全局可用）
 * 此文件出现的背景是：由于有些地方比如buyitem需要直接出一个弹窗
 * 但实际上用状态去管理，会导致页面状态非常复杂和难以维护
 * 因此对于简单的一些组件，比如alert/prompt推荐在这里直接使用
 * 使用场景：
 * 全局弹窗，不分场合的弹窗，或者不想用状态去维护的弹窗，可以使用此prompt
 * 对于组件内，状态确认的，可以使用原common/prompt组件
 */

let PreviewInstance = null

export default {
  install(Vue) {
    Vue.$Preview = Vue.prototype.$Preview = props => {
      if (PreviewInstance) {
        PreviewInstance.remove()
      }
      PreviewInstance = Create(Preview, props)
      return PreviewInstance
    }
  }
}
